module.exports = __webpack_public_path__ + "static/media/wireless-charging-desktop.189f601f.png";